import { vec3 } from 'gl-matrix';
import { AABB } from '../shapes';
import { dirtifyToRoot, GeometryUpdaterFactory } from '../services';
import { Shape } from '../types';
import { PARSED_COLOR_TYPE } from './color';
import { globalContainer } from '../global-module';
export function updateGeometry(oldValue, newValue, object) {
  var geometryUpdaterFactory = globalContainer.get(GeometryUpdaterFactory);
  var geometryUpdater = geometryUpdaterFactory(object.nodeName);

  if (geometryUpdater) {
    var geometry_1 = object.geometry;

    if (!geometry_1.contentBounds) {
      geometry_1.contentBounds = new AABB();
    }

    if (!geometry_1.renderBounds) {
      geometry_1.renderBounds = new AABB();
    }

    var _a = geometryUpdater.update(object.parsedStyle, object),
        width = _a.width,
        height = _a.height,
        _b = _a.depth,
        depth = _b === void 0 ? 0 : _b,
        _c = _a.x,
        x = _c === void 0 ? 0 : _c,
        _d = _a.y,
        y = _d === void 0 ? 0 : _d,
        _e = _a.z,
        z = _e === void 0 ? 0 : _e,
        _f = _a.offsetX,
        offsetX = _f === void 0 ? 0 : _f,
        _g = _a.offsetY,
        offsetY = _g === void 0 ? 0 : _g,
        _h = _a.offsetZ,
        offsetZ = _h === void 0 ? 0 : _h; // object.parsedStyle.width = width;
    // object.parsedStyle.height = height;
    // object.parsedStyle.depth = depth;


    if (object.nodeName === Shape.LINE || object.nodeName === Shape.POLYLINE || object.nodeName === Shape.POLYGON || object.nodeName === Shape.PATH) {
      object.parsedStyle.offsetX = x - (object.parsedStyle.defX || 0);
      object.parsedStyle.offsetY = y - (object.parsedStyle.defY || 0);
      object.parsedStyle.defX = x;
      object.parsedStyle.defY = y;
      object.translateLocal(object.parsedStyle.offsetX, object.parsedStyle.offsetY);
      object.parsedStyle.x = object.style.x;
      object.parsedStyle.y = object.style.y;
      object.parsedStyle.z = z;
    } else {
      object.parsedStyle.x = x;
      object.parsedStyle.y = y;
      object.parsedStyle.z = z;
    } // init with content box


    var halfExtents = vec3.fromValues(width / 2, height / 2, depth / 2); // anchor is center by default, don't account for lineWidth here

    var _j = object.parsedStyle,
        lineWidth = _j.lineWidth,
        _k = _j.anchor,
        anchor = _k === void 0 ? [0, 0] : _k,
        shadowColor = _j.shadowColor,
        _l = _j.filter,
        filter = _l === void 0 ? [] : _l; // <Text> use textAlign & textBaseline instead of anchor

    if (object.nodeName === Shape.TEXT) {
      delete object.parsedStyle.anchor;
    }

    var center = vec3.fromValues((1 - anchor[0] * 2) * halfExtents[0] + offsetX, (1 - anchor[1] * 2) * halfExtents[1] + offsetY, (1 - (anchor[2] || 0) * 2) * halfExtents[2] + offsetZ); // update geometry's AABB

    geometry_1.contentBounds.update(center, halfExtents);

    if (lineWidth) {
      // append border
      vec3.add(halfExtents, halfExtents, vec3.fromValues(lineWidth.value / 2, lineWidth.value / 2, 0));
    }

    geometry_1.renderBounds.update(center, halfExtents); // account for shadow, only support constant value now

    if (shadowColor && shadowColor.type === PARSED_COLOR_TYPE.Constant) {
      var _m = geometry_1.renderBounds,
          min = _m.min,
          max = _m.max;
      var _o = object.parsedStyle,
          _p = _o.shadowBlur,
          shadowBlur = _p === void 0 ? 0 : _p,
          _q = _o.shadowOffsetX,
          shadowOffsetX = _q === void 0 ? 0 : _q,
          _r = _o.shadowOffsetY,
          shadowOffsetY = _r === void 0 ? 0 : _r;
      var shadowLeft = min[0] - shadowBlur + shadowOffsetX;
      var shadowRight = max[0] + shadowBlur + shadowOffsetX;
      var shadowTop = min[1] - shadowBlur + shadowOffsetY;
      var shadowBottom = max[1] + shadowBlur + shadowOffsetY;
      min[0] = Math.min(min[0], shadowLeft);
      max[0] = Math.max(max[0], shadowRight);
      min[1] = Math.min(min[1], shadowTop);
      max[1] = Math.max(max[1], shadowBottom);
      geometry_1.renderBounds.setMinMax(min, max);
    } // account for filter, eg. blur(5px), drop-shadow()


    filter.forEach(function (_a) {
      var name = _a.name,
          params = _a.params;

      if (name === 'blur') {
        var blurRadius = params[0].value;
        geometry_1.renderBounds.update(geometry_1.renderBounds.center, vec3.add(geometry_1.renderBounds.halfExtents, geometry_1.renderBounds.halfExtents, vec3.fromValues(blurRadius, blurRadius, 0)));
      } else if (name === 'drop-shadow') {
        var shadowOffsetX = params[0].value;
        var shadowOffsetY = params[1].value;
        var shadowBlur = params[2].value;
        var _b = geometry_1.renderBounds,
            min = _b.min,
            max = _b.max;
        var shadowLeft = min[0] - shadowBlur + shadowOffsetX;
        var shadowRight = max[0] + shadowBlur + shadowOffsetX;
        var shadowTop = min[1] - shadowBlur + shadowOffsetY;
        var shadowBottom = max[1] + shadowBlur + shadowOffsetY;
        min[0] = Math.min(min[0], shadowLeft);
        max[0] = Math.max(max[0], shadowRight);
        min[1] = Math.min(min[1], shadowTop);
        max[1] = Math.max(max[1], shadowBottom);
        geometry_1.renderBounds.setMinMax(min, max);
      }
    });
    dirtifyToRoot(object);
  }
}